export default __webpack_public_path__ + "static/media/0x2c92a8a41f4b806a6f6f1f7c9d9dec78dcd8c18e.62d9daa8.webp";